import axios from "axios";
import React, { useState } from "react";
import endpoints from "../utility/endpoints";
export const menuList = (order) => {
  const [skills, setSkills] = useState([]);

  let type = "";
  if (order === 1) {
    type = "Supply Chain";
  }

  if (order === 2) {
    type = "Finance";
  }

  if (order === 3) {
    type = "Marketing";
  }

  if (order === 4) {
    type = "HR Services";
  }
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const skillstat = async (e) => {
    const { data } = await axios({
      url: `${endpoints.baseUrl}/twin/getETbyLeadPlatform`,
      method: "POST",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },
      data: {
        leadPlatform: type,
      },
    });
    if (data.code === 200) {
      // Filter soft skill data

      setSkills(data);
    } else {
      console.log("No data found");
    }
  };

  React.useEffect(() => {
    skillstat();
  }, []);

  const supplyChain = [
    {
      label: skills.etname ? `Explore ${skills.etname}` : "Explore",
      list:
        skills && skills && skills.data
          ? skills.data.slice(0, 5).map((item) => ({
              label: item.processName,
              url: `${endpoints.redirectUriLogin}/botDetails?botID=${window.btoa(item.id)}`,
            }))
          : [],
    },

    {
      label: "Soft Skills",
      list:
        skills && skills && skills.softSkill
          ? skills.softSkill.map((item) => ({
              label: item.processName,
              url: `${endpoints.redirectUriLogin}/softskilldetails?softSkillID=${item.botID}`,
            }))
          : [],
    },
  ];

  const finance = [
    {
      label: skills.etname ? `Explore ${skills.etname}` : "Explore",
      list:
        skills && skills && skills.data
          ? skills.data.slice(0, 5).map((item) => ({
              label: item.processName,
              url: `${endpoints.redirectUriLogin}/botDetails?botID=${window.btoa(item.id)}`,
            }))
          : [],
    },

    {
      label: "Soft Skills",
      list:
        skills && skills && skills.softSkill
          ? skills.softSkill.map((item) => ({
              label: item.processName,
              url: `${endpoints.redirectUriLogin}/softskilldetails?softSkillID=${item.botID}`,
            }))
          : [],
    },
  ];

  const hr_services = [
    {
      label: skills.etname ? `Explore ${skills.etname}` : "Explore",
      list:
        skills && skills && skills.data
          ? skills.data.slice(0, 5).map((item) => ({
              label: item.processName,
              url: `${endpoints.redirectUriLogin}/botDetails?botID=${window.btoa(item.id)}`,
            }))
          : [],
    },

    {
      label: "Soft Skills",
      list:
        skills && skills && skills.softSkill
          ? skills.softSkill.map((item) => ({
              label: item.processName,
              url: `${endpoints.redirectUriLogin}/softskilldetails?softSkillID=${item.botID}`,
            }))
          : [],
    },
  ];

  const marketing = [
    {
      label: skills.etname ? `Explore ${skills.etname}` : "Explore",
      list:
        skills && skills && skills.data
          ? skills.data.slice(0, 5).map((item) => ({
              label: item.processName,
              url: `${endpoints.redirectUriLogin}/botDetails?botID=${window.btoa(item.id)}`,
            }))
          : [],
    },

    {
      label: "Soft Skills",
      list:
        skills && skills && skills.softSkill
          ? skills.softSkill.map((item) => ({
              label: item.processName,
              url: `${endpoints.redirectUriLogin}/softskilldetails?softSkillID=${item.botID}`,
            }))
          : [],
    },
  ];

  if (order === 1) {
    return supplyChain;
  }

  if (order === 2) {
    return finance;
  }

  if (order === 3) {
    return marketing;
  }

  if (order === 4) {
    return hr_services;
  }
};

export const menuItems = [
  {
    label: "Supply Chain",
    href: "",
    key: 1,
  },
  {
    label: "Finance",
    href: "",
    key: 2,
  },
  {
    label: "Marketing",
    href: "",
    key: 3,
  },
  { label: "HR Services", href: "", key: 4 },
  {
    label: "HAP Products",
    href: `${endpoints.redirectUriLogin}/products`,
    key: 5,
  },
];

